"use strict";

import onInitModulesInsScope from "./onInitModulesInScope";

export function init() {
    onInitModulesInsScope(function initInScope($scope) {
        $scope.find('[data-toggle="tooltip"]').tooltip();
    })
}